import { TextField } from 'material-ui'
import React, { Component } from 'react'
import DateTimePicker from '../date-time-picker'
import Repeater from '../fieldList/repeater'
import DiscountSelector from './discount-selector'
import ConditionFields from '../dynamic-conditions/condition-fields'

class DiscountWindow extends Component<any, any> {
  render () {
    const { value, onChange, resource } = this.props
    return (
      <div style={{ width: '100%' }}>
        <TextField errorText={!value?.name ? 'Required' : undefined} value={value?.name} fullWidth onChange={(e) => onChange({
          ...value,
          name: e.target.value
        })} floatingLabelText='Name' />
        <DateTimePicker
          name='Start At'
          value={value?.start_at}
          errorText={!value?.start_at ? 'Required' : undefined}
          onChange={(_, startAt) => onChange({
            ...value,
            start_at: startAt
          })}
        />
        <DateTimePicker
          name='End At'
          value={value?.end_at}
          errorText={!value?.end_at ? 'Required' : undefined}
          onChange={(_, endAt) => onChange({
            ...value,
            end_at: endAt
          })}
        />
        <Repeater
          label={'Discounts'}
          value={value?.discounts}
          newValue={() => ({ conditions: {}, discount_id: null })}
          onChange={(_, discounts) => {
            onChange({ ...value, discounts })
          }}
          resource={resource}
          component={DiscountWindowDiscountConditions}
        />
      </div>
    )
  }
}

const DiscountWindowDiscountConditions = ({
  resource,
  value,
  onChange
}) => {
  return (
    <div>
      <DiscountSelector errorText={!value?.discount_id ? 'Required' : undefined} value={value?.discount_id} onChange={(_, discountId) => onChange({
        ...value,
        discount_id: discountId
      })} resource={resource} />
      <ConditionFields
        value={value?.conditions}
        onChange={(conditions) => onChange({ ...value, conditions })}
      />
    </div>
  )
}

export default DiscountWindow
